var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-title',[_c('h4',[_vm._v("Dashboard")])]),_c('v-divider'),(_vm.hasElements)?_c('product-usage-chart',{attrs:{"height":150,"elements":_vm.statistics.elements}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }